import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'quoteandbind.EnvProduct.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'quoteandbind.EnvProduct.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'quoteandbind.EnvProduct.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'quoteandbind.EnvProduct.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    // add string ids and default values for localization here
});
